module.exports = __webpack_public_path__ + "img/hr-tree-08-b-trunk.151f3316.png";